import { GATEWAY_URL } from "../config";
import { GatewayError } from "./liveRepository";

const withAssetUrls = (activity) => activity && ({
  ...activity,
  resolved_assets: Object.fromEntries(
    Object.entries(activity.resolved_assets || {}).map(([key, asset]) => [
      key,
      {
        ...asset,
        src: asset.src?.startsWith("/") ? `${GATEWAY_URL}${asset.src}` : asset.src,
      },
    ])
  ),
});

// A one-time adult-issued code becomes a short-lived, httpOnly preview cookie.
// The response contains approved curriculum only: no learner, release, attempt,
// response or evidence identity is fabricated.
export const redeemTeacherPreview = async (code) => {
  if (!GATEWAY_URL) throw new GatewayError(503, "gateway-not-configured");
  const response = await fetch(`${GATEWAY_URL}/preview/session`, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code }),
  });
  const data = await response.json().catch(() => null);
  if (!response.ok) throw new GatewayError(response.status, data?.reason);
  return withAssetUrls(data?.activity);
};
